import { useState } from "react";
import { MutateKitchenCategoryDrawer } from "./MutateKitchenCategoryDrawer";
import { ButtonPrimary } from "../../../components/NewButtons";
import { useSearchParamsManipulation } from "../../../hooks/use-searchparams-manipulation";

type Props = {
  id?: string;
};

export const MutateKitchenCategorySelector = ({ id }: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const { removeOption } = useSearchParamsManipulation();

  return (
    <div>
      <ButtonPrimary
        onClick={() => {
          removeOption();
          setModalOpen(true);
        }}
        type="button"
      >
        Create kitchen category
      </ButtonPrimary>
      <MutateKitchenCategoryDrawer
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        id={id}
      />
    </div>
  );
};
